export default {"src":"/_next/static/media/en.acf8510b.svg","height":30,"width":60};